import React, { useState } from 'react';
import useNavigateWithBase from "../hooks/useNavigateWithBase";
import axios from 'axios';
import '../CSS/AddCompany.css';

const AddCompany = () => {
  const [companyName, setCompanyName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [registeredInfo, setRegisteredInfo] = useState(null); // 登録結果を保存
  const [isLoading, setIsLoading] = useState(false); // ローディング状態
  const [isModalOpen, setIsModalOpen] = useState(false); // モーダル表示状態
  const navigate = useNavigateWithBase(); // ページ遷移用

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setRegisteredInfo(null);
    setIsLoading(true); // ローディング開始
  
    if (!companyName || !managerName) {
      setError('会社名と代表責任者名は必須です。');
      setIsLoading(false);
      return;
    }
  
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://cbo967jtmi.execute-api.ap-northeast-3.amazonaws.com/prod/api/companies',
        { 
          action: 'create',
          company_name: companyName, // ✅ 統一
          personal_name: managerName, // ✅ 統一
          email 
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.status === 201) {
        setSuccess('会社情報が正常に登録されました。');
        setRegisteredInfo({
          ...response.data,  // API レスポンスのデータ
          company_name: companyName,  // ✅ フォームで入力した値を追加
          personal_name: managerName,  // ✅ フォームで入力した値を追加
          email: email,  // ✅ フォームで入力した値を追加
        });
        setCompanyName('');
        setManagerName('');
        setEmail('');
        setIsModalOpen(true);
      }
    } catch (err) {
      console.error(err);
      setError('会社情報の登録中にエラーが発生しました。');
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="add-company-container">
      <h1>企業新規追加</h1>

      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="companyName">会社名</label>
          <input
            type="text"
            id="companyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="例: 株式会社 綾鳥"
            required
            disabled={isLoading} // ローディング中は入力不可
          />
        </div>

        <div className="form-group">
          <label htmlFor="managerName">代表責任者名</label>
          <input
            type="text"
            id="managerName"
            value={managerName}
            onChange={(e) => setManagerName(e.target.value)}
            placeholder="例: 山田 太郎"
            required
            disabled={isLoading} // ローディング中は入力不可
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">メールアドレス（任意）</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="例: example@example.com"
            disabled={isLoading} // ローディング中は入力不可
          />
        </div>

        <button type="submit" className="submit-button" disabled={isLoading}>
          {isLoading ? '登録中です…' : '追加'} {/* ローディング中のボタン表示 */}
        </button>
      </form>

      {/* ポータルページへ戻るボタン */}
      <button
        className="back-button"
        onClick={() => navigate('/portal')}
        disabled={isLoading} // ローディング中はボタンも無効化
      >
        ポータルへ戻る
      </button>

      {/* モーダルウィンドウ */}
      {isModalOpen && registeredInfo && (
        <div className="modal">
          <div className="modal-content">
            <h2>登録結果</h2>
            <p><strong>会社コード:</strong> {registeredInfo.companyCode}</p>
            <p><strong>個人ID:</strong> {registeredInfo.personalId}</p> {/* 個人IDを追加 */}
            <p><strong>パスワード:</strong> {registeredInfo.password}</p>
            <p><strong>会社名:</strong> {registeredInfo.company_name}</p> {/* ✅ 修正 */}
            <p><strong>責任者名:</strong> {registeredInfo.personal_name}</p> {/* ✅ 修正 */}
            <p><strong>メールアドレス:</strong> {registeredInfo.email || '未登録'}</p>
            <button className="close-button" onClick={() => setIsModalOpen(false)}>
              閉じる
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCompany;
